import actions from './actions'
import mutations from './mutations'

const api = {
    state: {
        messages: []
    },
    mutations,
    actions
}

export default api
